import {Link} from 'react-router-dom';

import './SideMenu.scss';
import {useCallback, useContext, useRef} from "react";
import {useOnClickOutside} from "../common/clickoutside/useClickOutsideHook";
import {UserContext} from "../../state/UserContext";

const SideMenu = ({show, onClose, firstName, lastName, imgUrl}) => {
    const ref = useRef(null);
    const {logout, loggedUser, userImageUrl} = useContext(UserContext)

    const outsideClickHandler = useCallback(
        () => {
            if (show) {
                onClose();
            }
        },
        [show, onClose]
    );
    useOnClickOutside(ref, outsideClickHandler);


    return (
        <div
            className={`side-menu ${show ? 'side-menu--visible' : 'side-menu--hidden'}`}
            ref={ref}
        >
            <div
                className="close-button"
                onClick={onClose}
                role="button"
                tabIndex={0}
            />
            <div className="profile">
                <img
                    className="user-image"
                    src={userImageUrl || "./assets/images/user.png"}
                    alt="userImage"
                />
                <div className="user-data">
                    <p className="description">
                        You are logged in as:
                    </p>
                    <p className="username">
                        {loggedUser.name}
                    </p>
                    <div onClick={logout} className="logout" role="button" tabIndex={0}>
                        Logout
                    </div>
                </div>
            </div>
            <div className="menu-items">
                <Link className="menu-item" to="/">
                    Home
                </Link>
                <Link className="menu-item" to="/latest-lunch">
                    Latest Lunch
                </Link>
                <Link className="menu-item" to="/templates">
                    Lunch Templates
                </Link>
                <Link className="menu-item" to="/create-lunch">
                    Create Lunch
                </Link>
            </div>
        </div>
    );
}

export default SideMenu;
